import { render, staticRenderFns } from "./cor-unit-list.vue?vue&type=template&id=5d20b1f9&scoped=true"
import script from "./cor-unit-list.vue?vue&type=script&lang=js"
export * from "./cor-unit-list.vue?vue&type=script&lang=js"
import style0 from "./cor-unit-list.vue?vue&type=style&index=0&id=5d20b1f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d20b1f9",
  null
  
)

export default component.exports